import { ButtonCopy } from '@apps-common/components/elements/button/ButtonCopy'
import classNames from 'classnames'

interface IProps {
  label: string
  value?: string
  allowCopy?: boolean
  loading?: boolean
  classes?: string
}

export const DetailsItem: React.FC<IProps> = ({ label, value, allowCopy, loading, classes }) => (
  <>
    {loading && (
      <div className={classNames(classes, 'animate-pulse')}>
        <div className='h-[18px] w-[60%] bg-skeleton rounded mb-[4px]' />
        <div className='h-[24px] w-[40%] bg-skeleton rounded' />
      </div>
    )}
    {!loading && (
      <div className={classes}>
        <div className='jost text-[0.8em] sm:text-[0.9em] text-text-muted'>{label}</div>
        <div className='text-[0.85em] sm:text-[1em] flex items-center justify-start jost-light text-text text-nowrap'>
          <div className='text-ellipsis overflow-hidden'>{value}</div>
          {allowCopy && <ButtonCopy value={value} />}
        </div>
      </div>
    )}
  </>
)
